import utilities from '@/services/utilities/utilities';
import store from '@/store';
import constants from '@/services/constants';

export default {
  checkTextValidity: function (text) {
    let textParts = text.split(','); // 'aa, jj-99' --> ['aa', 'jj-99']
    let invalidParts = [];

    if (text === '') {
      return {
        valid: true,
      };
    }

    textParts.forEach(function (textPart) {
      if (!this._isTextPartValid(textPart)) {
        invalidParts.push(textPart);
      }
    }, this);

    return {
      valid: invalidParts.length === 0,
      invalidParts: invalidParts,
    };
  },
  /*
    valid text parts:
      [singleHand]
      [singleHand]+
        except aa+, aks+, 87s+, etc.
      [singleHand]-
        except 22-, a2s-, 82s-, etc.
      [singleHand]-[singleHand]
        except pair-suited, offsuit-suit, etc.
  */
  _isTextPartValid: function (textPart) {
    textPart = textPart.toLowerCase();
    let textPartType = this.__getTextPartType(textPart);


    // [handPart]+
    if (textPartType === 'plus') {
      return this.__isTextPartPlusValid(textPart);
    }

    // [handPart]-
    else if (textPartType === 'minus') {
      return this.__isTextPartMinusValid(textPart);
    }

    // [handPart]-[handPart]
    else if (textPartType === 'range') {
      return this.__isTextPartRangeValid(textPart);
    }

    // [handPart]
    else if (textPartType === 'individual hand') {
      return this.__isHandValid(textPart) || this.__isSpecificHandValid(textPart);
    }
  },
  __getTextPartType: function (textPart) {
    let plusSplit = textPart.split('+');
    let dashSplit = textPart.split('-');
    let hasPlus = plusSplit.length > 1;
    let hasMinus = false;
    let hasDash = false;

    // there's one dash
    if (dashSplit.length === 2) {
      // ends in a dash
      if (textPart[textPart.length - 1] === '-') {
        hasMinus = true;
      } else {
        hasDash = true;
      }
    }

    if (hasPlus) {
      return 'plus';
    } else if (hasMinus) {
      return 'minus';
    } else if (hasDash) {
      return 'range';
    } else {
      return 'individual hand';
    }
  },
  __isTextPartPlusValid: function (textPart) {
    let plusSplit = textPart.split('+');

    // + needs to be at the end
    if (plusSplit[1].length > 0) {
      return false;
    }

    // in [handPart]+, [handPart] needs to be valid
    if (!this.__isHandValid(plusSplit[0])) {
      return false;
    }

    // + not applicable for these
    if ([
      'aa+', 'aks+', 'ako+', 'ak+'
    ].includes(textPart)) {
      return false;
    }

    // otherwise, [handPart]+ is valid
    return true;
  },
  __isTextPartMinusValid: function (textPart) {
    let dashSplit = textPart.split('-');

    // - needs to be at the end
    if (dashSplit[1].length > 0) {
      return false;
    }

    // in [handPart]-, [handPart] needs to be valid
    if (!this.__isHandValid(dashSplit[0])) {
      return false;
    }

    // - not applicable for these
    if ([
      '22-',
      'a2s-', 'k2s-', 'q2s-', 'j2s-', 't2s-', '92s-', '82s-', '72s-', '62s-', '52s-', '42s-', '32s-',
      'a2o-', 'k2o-', 'q2o-', 'j2o-', 't2o-', '92o-', '82o-', '72o-', '62o-', '52o-', '42o-', '32o-',
      'a2-', 'k2-', 'q2-', 'j2-', 't2-', '92-', '82-', '72-', '62-', '52-', '42-', '32-'
    ].includes(textPart)) {
      return false;
    }

    // otherwise, [handPart]- is valid
    return true;
  },
  __isTextPartRangeValid: function (textPart) {
    let dashSplit = textPart.split('-');
    let rangeLeftType;
    let rangeRightType;

    // should only be one dash in [handPart]-[handPart]
    if (dashSplit.length > 2) {
      return false;
    }


    if (textPart.length === 7) {
      // K7s-KJs should be invalid
      if (utilities.ranks.isFirstRankLargerThanSecond(textPart[5], textPart[1])) {
        return false;
      }
    }

    if (textPart.length === 5) {
      // 55-99 should be invalid
      if (utilities.ranks.isFirstRankLargerThanSecond(textPart[3], textPart[0])) {
        return false;
      }
    }

    // in [handPart]-[handPart], both handParts need to be valid
    if (!this.__isHandValid(dashSplit[0])) {
      return false;
    }
    if (!this.__isHandValid(dashSplit[1])) {
      return false;
    }

    if (dashSplit[0].includes('s')) {
      rangeLeftType = 'suited';
    } else if (dashSplit[0].includes('o')) {
      rangeLeftType = 'offsuit';
    } else {
       rangeLeftType = 'pair';
    }

    if (dashSplit[1].includes('s')) {
      rangeRightType = 'suited';
    } else if (dashSplit[1].includes('o')) {
      rangeRightType = 'offsuit';
    } else {
       rangeRightType = 'pair';
    }

    if (rangeLeftType === rangeRightType) {
      return true;
    } else {
      return false;
    }
  },
  __isHandValid: function (handString) {
    handString = handString.toLowerCase();

    if (
      handString.length === 2 &&
      handString[0] !== handString[1] &&
      constants.ranks.includes(handString[0]) &&
      constants.ranks.includes(handString[1])
    ) {
      return true;
    }

    return constants.handRankings['ten-handed-evolutionary'].includes(handString);
  },
  __isSpecificHandValid: function (handString) {
    if (handString.length !== 4) {
      return false;
    }

    handString = utilities.hands.getNormalizedSpecificHandString(handString);
    return constants.specificHandStrings.includes(handString);
  },
};



// WEBPACK FOOTER //
// ./src/services/text/validate.js